import React from 'react';
import PropTypes from 'prop-types';

import HubModel from 'models/hub';
import Brand from 'models/brand';

import NycNeighborhoods from 'components/hub/nyc-neighborhoods';
import PopularDestinations from 'components/hub/popular-destinations';

const propTypes = {
  hub: PropTypes.instanceOf(HubModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const NycOrRegularPopularDestinations = ({ hub, brand }) => {
  if (hub.isNYC && !brand.isBestParking) {
    return (
      <div>
        <div className="col-xs-12 col-md-6">
          <div className="row">
            <PopularDestinations
              hub={hub}
            />
          </div>
        </div>
        <div className="hidden-md">
          <NycNeighborhoods scaleFactor={0.52} />
        </div>
        <div className="hidden-lg">
          <NycNeighborhoods scaleFactor={0.44} />
        </div>
      </div>
    );
  }
  return (
    <PopularDestinations
      hub={hub}
      brand={brand}
    />
  );
};

NycOrRegularPopularDestinations.propTypes = propTypes;

export default NycOrRegularPopularDestinations;
